// The shapes a dashboard section's top-level items are drawn as. A stack is
// a card of its own. A single pull request is a flat row, and singles that
// follow one another are joined into one list: a run reads as one object,
// and nothing is joined to a stack.

export interface Shape {
  kind: 'single' | 'stack';
  /** A single joined to the single before it (no gap, one hairline between them). */
  joinsAbove: boolean;
  /** A single joined to the single after it. */
  joinsBelow: boolean;
}

/** Each item's shape, from the kinds of the items in order. */
export function shapesOf(kinds: readonly ('single' | 'stack')[]): Shape[] {
  return kinds.map((kind, i) => ({
    kind,
    joinsAbove: kind === 'single' && kinds[i - 1] === 'single',
    joinsBelow: kind === 'single' && kinds[i + 1] === 'single',
  }));
}
